import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import SvgIcon from '@mui/material/SvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ContextSwitcherIcon = function ContextSwitcherIcon(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({
    viewBox: "0 0 500 500"
  }, props), {}, {
    "data-element": "SvgIcon",
    "data-component": "ContextSwitcherIcon",
    "data-source-file": "context-switcher.tsx",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "201.6",
      cy: "127.8",
      r: "64.6",
      "data-element": "circle",
      "data-component": "ContextSwitcherIcon",
      "data-source-file": "context-switcher.tsx"
    }), /*#__PURE__*/_jsx("path", {
      d: "M217.7 337.6c0-39.1 17.4-74 44.9-97.7-18.2-9.7-38.9-15.3-61-15.3-65.7 0-120 48.6-129 111.8-1.4 9.8 6.3 18.5 16.2 18.5H219c-.8-5.7-1.3-11.4-1.3-17.3zM439 258.3l-51.7-51.7c-6.3-6.3-16.5-6.3-22.8 0-6.3 6.3-6.3 16.5 0 22.8l24.1 24.1H308c-47.4 0-64.6 38.4-64.6 64.2 0 8.9 7.1 16 16 16.1h.1c8.8 0 16-7.1 16.1-16 .1-7.5 2.8-32.1 32.3-32.1h80.4L364.1 310c-6.3 6.3-6.4 16.5-.1 22.8 3.2 3.2 7.3 4.8 11.5 4.8 4.1 0 8.2-1.5 11.4-4.7l52.1-51.7c3.1-3 4.8-7.1 4.8-11.4-.1-4.3-1.8-8.4-4.8-11.5z",
      "data-element": "path",
      "data-source-file": "context-switcher.tsx"
    }), /*#__PURE__*/_jsx("path", {
      d: "M427.7 321.6h-.1c-8.8 0-16 7.1-16.1 16-.1 7.5-2.8 32.1-32.3 32.1h-80.4l24.3-24.1c6.3-6.3 6.4-16.5.1-22.8-6.3-6.3-16.5-6.3-22.8-.1l-52.1 51.8c-3.1 3-4.8 7.1-4.8 11.4 0 4.3 1.7 8.4 4.7 11.4l51.7 51.7c3.2 3.2 7.3 4.7 11.4 4.7 4.1 0 8.3-1.6 11.4-4.7 6.3-6.3 6.3-16.5 0-22.8l-24.1-24.1h80.6c47.4 0 64.6-38.4 64.6-64.2-.1-9.1-7.3-16.2-16.1-16.3z",
      "data-element": "path",
      "data-source-file": "context-switcher.tsx"
    })]
  }));
};